import React, { useState, useEffect, Component } from 'react';
import { connect } from 'react-redux'

import '../../assets/css/tor-template-list.css'
import { DatePicker,Select,InputDecimal,DropDownMuti } from '../../components/core';
import $ from 'jquery'
import { SecureGateRoute, BreadCrumb, DetailBotLogModal } from '../../components';
import { searchReportAction } from '../../redux/actions/ReportAction'
import ReportTablePage from '../../components/Report/ReportTablePage';
import {AppSettings } from '../../configs'
import { Storage } from "../../configs";
import {
    data_status,
} from '../../configs/datas'

import moment from 'moment'
import {msg} from '../../components/Notifications/MsgBox';
import ReactTooltip from 'react-tooltip'
import { AdjustmentService } from '../../services';
import UserServices from '../../services/UserServices';
import { useHistory } from "react-router";
import AdjustmentTable from './Table/AdjustmentTable';


const serachCondition = {
    PO_CONTRACT_NO: '',
    HEADER_TEXT: '',
    COMPANY: '',
    CREATE_BY: '',
    CREATE_DATE_FROM: '',
    CREATE_DATE_TO: '',
    MUTI_STATUS: '',
}


export default () => {
    const [serachConditionModel,setsearchData] = useState({});
    const [resultSearch,setResultSearch] = useState([]);
    const history = useHistory();
    const [appReadonly,setAppReadonly] = useState(true);

    const statusOptions = () => {
        return Promise.resolve([
            {
                value: "DRAFT",
                label: "Draft"
            },
            {
                value: "WAITFAPP",
                label: "Waitting for Approve"
            },
            {
                value: "COMPLETE",
                label: "Complete"
            },
            {
                value: "REJECT",
                label: "Reject"
            },
        ]);
    }

    const handleApplicationCheckReadonly = async () =>
    {
        UserServices.ApplicationReadonly().then(response=>{
            if(response.data === false)
            {
                setAppReadonly(false)
            }
        })
    }

    useEffect(() => {
        setsearchData({...serachCondition});
        searchReportAction(serachConditionModel);
        handleApplicationCheckReadonly();
      }, [])

    function searchReportAction(serachConditionModel) {

        try {

            AdjustmentService.searchReportAction(serachConditionModel).then((response) => {
                console.log("searchReportAction");
                console.log(response);
                if(response.success)
                {
                    setResultSearch(response.data)
                }else{
                    setResultSearch([])
                    msg.error(response.message)
                }
            })
        } catch (e) {
            console.log(e);
            //showMessage("error", "System error.", true);
        }
    }

    const handleChangeSerachConditionModel = (event) => {

        const target = event.target
        let value = target.type === 'checkbox' ? target.checked : target.value
        const name = target.name

        //check date
        if (target.className) {
            if ((target.className.indexOf("js-datepicker") > -1 || target.className.indexOf("js-datepicker-all") > -1) && (value.toString()).indexOf("/") > 0) {
                let dateData = (value.toString()).split("/")
                let dateDataLength = dateData.length
                if (dateDataLength === 3) {
                    if (moment(value, 'DD/MM/YYYY').isValid()) {
                        value = moment(value, 'DD/MM/YYYY').format('DD/MM/YYYY')
                    }
                }
            }
        }

        serachConditionModel[name] = value;
        setsearchData({ ...serachConditionModel});
        console.log("handleChangeSerachConditionModel")
        console.log(serachConditionModel);

      };

      const handleSearch = (event) => {
        searchReportAction(serachConditionModel);
      };

      const handleClear = (event) => {
        setsearchData({...serachCondition});
        searchReportAction({...serachCondition});
      };
      
      const handleAdd = (event) => {
        history.push(`/AdjustmentDetail/${0}`);
      };

      const handleDropdownMutiChange = (objs)=>{
          if(objs)
          {
              if(objs.length > 0)
              {
                setsearchData((previous => ({...previous,'MUTI_STATUS':objs})))
              }
          }

          console.log('objs',objs)
      }

        return (
            <div className="tor tor-template-list">
                <SecureGateRoute/>
                <div id="main-content">
                    <div className="page-body">
                        <BreadCrumb breadcrumb={[
                            {name:'RRS Home',url:AppSettings.defaultUrl},
                            {name:'หนังสือเกี่ยวข้องกับการปรับ',url:''}
                        ]}></BreadCrumb>

                        <div className="sp-page-header-panel row">
                            <div className="col-md-5 sp-page-header">
                                <h1 className="sp-page-header1">หนังสือเกี่ยวข้องกับการปรับ</h1>
                            </div>
                        </div>

                        <div className="sp-page-result-container">
                            
                        <div className="row">
                            <div className="col-md-6">
                                <div className="rrs-detail-data">
                                    <label htmlFor="gr_post_date" className="rrs-label mb-0">PO/Contract No.</label>
                                </div>
                                <div className="rrs-detail-data">
                                    <div className="form-group">
                                        <input
                                            type="text"
                                            id="PO_CONTRACT_NO"
                                            name="PO_CONTRACT_NO"
                                            className="form-control"
                                            placeholder="ข้อมูล Purchase / Contract Number"
                                            //defaultValue={serachConditionModel.PO_CONTRACT_NO}
                                            value={serachConditionModel.PO_CONTRACT_NO}
                                            onChange={handleChangeSerachConditionModel}
                                            maxLength={10}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                            <div className="rrs-detail-data">
                                <label htmlFor="gr_post_date" className="rrs-label mb-0">ชื่องาน</label>
                            </div>
                            <div className="rrs-detail-data">
                                    <div className="form-group">
                                        <input
                                            type="text"
                                            id="HEADER_TEXT"
                                            name="HEADER_TEXT"
                                            className="form-control"
                                            placeholder="ชื่องาน"
                                            //defaultValue={serachConditionModel.HEADER_TEXT}
                                            value={serachConditionModel.HEADER_TEXT}
                                            onChange={handleChangeSerachConditionModel}
                                            maxLength={250}
                                        />
                                    </div>
                                </div>

                        </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6">
                                <div className="rrs-detail-data">
                                    <label htmlFor="gr_post_date" className="rrs-label mb-0">Company</label>
                                </div>
                                <div className="rrs-detail-data">
                                    <div className="form-group">
                                        <input
                                            type="text"
                                            id="COMPANY"
                                            name="COMPANY"
                                            className="form-control"
                                            placeholder="ข้อมูล Company"
                                            //defaultValue={serachConditionModel.COMPANY}
                                            value={serachConditionModel.COMPANY}
                                            onChange={handleChangeSerachConditionModel}
                                            maxLength={150}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                            <div className="rrs-detail-data">
                                <label htmlFor="gr_post_date" className="rrs-label mb-0">Create By</label>
                            </div>
                            <div className="rrs-detail-data">
                                <div className="form-group">
                                    <input
                                        type="text"
                                        id="CREATE_BY"
                                        name="CREATE_BY"
                                        className="form-control"
                                        value={serachConditionModel.CREATE_BY}
                                        //defaultValue={serachConditionModel.CREATE_BY}
                                        onChange={handleChangeSerachConditionModel}
                                        maxLength={100}
                                    />
                                </div>
                            </div>

                        </div>
                        </div>

                        <div className="row">
                        <div className="col-md-6">
                                <div className="rrs-detail-data">
                                    <label htmlFor="gr_delivery_note" className="rrs-label mb-0">Status</label>
                                </div>
                                <div className="rrs-detail-data">
                                    <div className="form-group">
                                      
                                        <DropDownMuti
                                        loadOptions={statusOptions}
                                        id="MUTI_STATUS"
                                        value={serachConditionModel.MUTI_STATUS}
                                        className="form-control"
                                        placeholder=""
                                        onChange={handleDropdownMutiChange}
                                        // onChange={this.handleChange('runningNoSelectedOptions')}
                                        // value={this.state.runningNoSelectedOptions}
                                        >
                                        </DropDownMuti>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="rrs-detail-data">
                                    <label htmlFor="gr_post_date" className="rrs-label mb-0">Create Date</label>
                                </div>
                                <div className="row">
                                    <div className="col-md-1 text-right"><span style={{ fontSize: '1rem' }}>From: </span></div>
                                    <div className="col-md-5">
                                        <DatePicker
                                            name="CREATE_DATE_FROM"
                                            id="CREATE_DATE_FROM"
                                            placeholder="dd/mm/yyyy"
                                            data-date-format="dd/mm/yyyy"
                                            //defaultValue={serachConditionModel.CREATE_DATE_FROM}
                                            value={serachConditionModel.CREATE_DATE_FROM}
                                            onChange={handleChangeSerachConditionModel}
                                            onBlur={handleChangeSerachConditionModel}
                                            readOnly={true}
                                            //ref={this.create_date_from_ref}
                                        />
                                    </div>
                                    <div className="col-md-1 text-right"><span style={{ fontSize: '1rem' }}>To: </span></div>
                                    <div className="col-md-5">
                                        <DatePicker
                                            name="CREATE_DATE_TO"
                                            id="CREATE_DATE_TO"
                                            placeholder="dd/mm/yyyy"
                                            data-date-format="dd/mm/yyyy"
                                            //defaultValue={serachConditionModel.CREATE_DATE_TO}
                                            value={serachConditionModel.CREATE_DATE_TO}
                                            onChange={handleChangeSerachConditionModel}
                                            onBlur={handleChangeSerachConditionModel}
                                            readOnly={true}
                                            //ref={this.create_date_to_ref}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <br></br>
                        <div className="rrs-detail2">
                            <div className="rrs-form-group-search">
                                <div className="row justify-content-center mx-0">
                                    <div className="col-md-12"/>
                                        <div className="col-md-4" style={{ textAlign: "left", paddingTop:20 }}>
                                            { appReadonly == false && <a onClick={handleAdd} className="sp-bt-addmore" style={{ cursor: 'pointer', marginLeft: 10, marginRight: 10 }}>
                                                <i className="icon btn-plus" /> 
                                                <span>เพิ่ม</span>
                                            </a>}
                                        </div>
                                        <div className="col-md-4">
                                            <a onClick={handleSearch} style={{ cursor: 'pointer' }}>
                                                <i className="icon btn-order-search"  />
                                            </a>
                                            <a onClick={handleClear} style={{ cursor: 'pointer',marginLeft:10,marginRight:10 }}> 
                                                <i className="icon btn-order-clear"  />
                                            </a>
                                        </div>
                                        <div className="col-md-4" style={{textAlign:"right"}}>
                                            
                                        </div>
                                </div>
                            </div>
                        </div>

                        <br></br>
                            <div className="rrs-detail2">
                                <div className="sp-table-container">
                                    <div className="row no-gutters sp-table-content">
                                        <AdjustmentTable
                                            dataTable_Adjustment={resultSearch}
                                            length={0}
                                        ></AdjustmentTable>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                        {/* <DetailBotLogModal /> */}
                    </div>
                </div>

                
            </div >
        )

}